//test
export const increment = ({commit}) => {
    commit('INCREMENT')
}
export const decrement = ({commit}) => {
    commit('DECREMENT')
}

export const setGroupId = ({commit},groupid) =>{
	setCookie('groupid', groupid,'Session');
	commit('SETGROUPID',groupid)
}

export const setUser = ({commit},user) => {
	setCookie('user',user);
	commit('SETUSER',user);
}



// WEBPACK FOOTER //
// ./src/vuex/actions.js